import React,{useState}from'react';
import * as FiIcons from'react-icons/fi';
import SafeIcon from'../common/SafeIcon';
import{createRepeatingField,getRepeatingFields}from'../utils/repeatingFields';
import'./repeating-fields.css';

const{FiChevronDown,FiChevronUp,FiGripVertical,FiPlus,FiTrash2}=FiIcons;
const fieldTypes=['Short text','Long text','Number','Date','Time','Yes / No','Single select','Multiple select','Dropdown','Song entry'];

function RepeatingFieldsEditor({question,onChange}){
  const[draggedIndex,setDraggedIndex]=useState(null);
  const fields=getRepeatingFields(question);

  const updateFields=nextFields=>onChange({...question,fields:nextFields});

  const updateField=(index,changes)=>{
    updateFields(fields.map((field,fieldIndex)=>(
      fieldIndex===index?{...field,...changes}:field
    )));
  };

  const updateOptions=(index,value)=>{
    updateField(index,{
      options:value.split(',').map(option=>option.trim()).filter(Boolean)
    });
  };

  const moveField=(index,direction)=>{
    const target=index+direction;
    if(target<0||target>=fields.length)return;
    const next=[...fields];
    [next[index],next[target]]=[next[target],next[index]];
    updateFields(next);
  };

  const dropField=targetIndex=>{
    if(draggedIndex===null||draggedIndex===targetIndex){
      setDraggedIndex(null);
      return;
    }

    const next=[...fields];
    const[moved]=next.splice(draggedIndex,1);
    next.splice(targetIndex,0,moved);
    updateFields(next);
    setDraggedIndex(null);
  };

  return <div className="repeating-fields-editor">
    <div className="repeating-fields-heading">
      <div>
        <strong>Client table rows</strong>
        <span>These columns and rows are shown to the client for each repeated entry.</span>
      </div>
      <button
        type="button"
        className="button secondary repeating-field-add"
        onClick={()=>updateFields([...fields,createRepeatingField()])}
      >
        <SafeIcon icon={FiPlus}/> Add column
      </button>
    </div>

    <div className="repeating-fields-list">
      {fields.length===0&&<p className="repeating-fields-empty">
        No table columns available. Add a column to create the repeating answer set.
      </p>}

      {fields.map((field,index)=>{
        const supportsOptions=['Single select','Multiple select','Dropdown'].includes(field.type);

        return <div
          className={`repeating-field-row ${draggedIndex===index?'dragging':''}`}
          key={field.id}
          draggable
          onDragStart={()=>setDraggedIndex(index)}
          onDragOver={event=>event.preventDefault()}
          onDrop={()=>dropField(index)}
          onDragEnd={()=>setDraggedIndex(null)}
        >
          <span className="repeating-field-handle" title="Drag to reorder">
            <SafeIcon icon={FiGripVertical}/>
          </span>
          <input
            value={field.label||''}
            onChange={event=>updateField(index,{label:event.target.value})}
            aria-label={`Repeating field ${index+1} label`}
          />
          <select
            value={field.type||'Short text'}
            onChange={event=>updateField(index,{type:event.target.value})}
            aria-label={`Repeating field ${index+1} type`}
          >
            {fieldTypes.map(type=><option key={type}>{type}</option>)}
          </select>
          {supportsOptions&&<input
            value={(field.options||[]).join(',')}
            onChange={event=>updateOptions(index,event.target.value)}
            placeholder="Answer options separated by commas"
            aria-label={`Answer options for ${field.label||`field ${index+1}`}`}
          />}
          <label className="repeating-field-required">
            <input
              type="checkbox"
              checked={Boolean(field.required)}
              onChange={event=>updateField(index,{required:event.target.checked})}
            />
            Required
          </label>
          <div className="repeating-field-actions">
            <button
              type="button"
              className="icon-btn"
              disabled={index===0}
              onClick={()=>moveField(index,-1)}
              aria-label="Move column left"
            >
              <SafeIcon icon={FiChevronUp}/>
            </button>
            <button
              type="button"
              className="icon-btn"
              disabled={index===fields.length-1}
              onClick={()=>moveField(index,1)}
              aria-label="Move column right"
            >
              <SafeIcon icon={FiChevronDown}/>
            </button>
            <button
              type="button"
              className="icon-btn danger"
              onClick={()=>updateFields(fields.filter((_,fieldIndex)=>fieldIndex!==index))}
              aria-label={`Delete ${field.label||`field ${index+1}`}`}
            >
              <SafeIcon icon={FiTrash2}/>
            </button>
          </div>
        </div>;
      })}
    </div>

    <div className="repeating-preview">
      <div className="repeating-preview-heading">
        <strong>Client preview</strong>
        <span>Actual table layout</span>
      </div>
      <div className="repeating-table-wrap">
        <table className="repeating-table repeating-preview-table">
          <thead>
            <tr>
              <th scope="col">Entry</th>
              {fields.map(field=><th scope="col" key={field.id}>
                {field.label||'Untitled column'}{field.required&&<b>*</b>}
              </th>)}
              <th scope="col"><span className="sr-only">Remove</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">#1</th>
              {fields.map(field=><td key={field.id}>—</td>)}
              <td/>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>;
}

export default RepeatingFieldsEditor;